import { BoxShadowWithRadius } from 'accessibility/focusStyles'
import cx from 'classnames'
import { Download } from 'components/lib/icons'
import useKeyboardNavigation from 'hooks/useKeyboardNavigation'
import useThemeColors from 'hooks/useThemeColors'
import React, { useRef } from 'react'
import { MessageSenderType } from 'types/message'

interface Attachment {
  fileName?: string,
  publicUrl?: string
}

interface FileAttachmentMessageProps {
  attachment?: Attachment,
  multi: Boolean,
  senderType: MessageSenderType
}


const FileAttachmentMessage = ({ attachment = {}, multi, senderType = MessageSenderType.END_USER }: FileAttachmentMessageProps) => {
  const {
    activeColor,
    agentIconTheme,
    buttonStyles,
    svgStyles,
  } = useThemeColors()
  const fileAttachmentRef = useRef<HTMLAnchorElement>(null)
  const isFileAttachmentFocused = useKeyboardNavigation(fileAttachmentRef)

  if (!attachment.fileName) {
    return null
  }

  const attachmentIconStyle = senderType === MessageSenderType.END_USER
    ? svgStyles
    : agentIconTheme

  return (
    <a
      href={attachment.publicUrl}
      target="_blank"
      rel="nofollow noopener noreferrer"
      className={cx("drift-widget-message--file", {
        'keyboard-focused': isFileAttachmentFocused
      })}
      style={multi ? buttonStyles : {}}
      aria-label={`Click to download file: ${attachment.fileName}`}
      ref={fileAttachmentRef}
    >
      <style>
        {`
          .drift-widget-message--file.keyboard-focused {
            ${BoxShadowWithRadius(activeColor, false)}
          }
        `}
      </style>
      <Download fill={attachmentIconStyle.fill} width={16} height={16} />
      <span className="drift-widget-attachment--filename" title={attachment.fileName}>
        {attachment.fileName}
      </span>
    </a>
  )
}

export default FileAttachmentMessage
